export function insertInlineStyle(_a) {
    var innerHTML = _a.innerHTML;
    var style = document.createElement('style');
    style.innerHTML = innerHTML;
    document.head.appendChild(style);
}
